import { Sparkles } from "lucide-react";

export const Logo = ({ size = "md", linkable = true }) => {
    const sizes = {
        sm: { title: "text-xl", sub: "text-base", icon: 14 },
        md: { title: "text-2xl md:text-3xl", sub: "text-lg md:text-xl", icon: 18 },
        lg: { title: "text-4xl md:text-5xl", sub: "text-2xl md:text-3xl", icon: 22 },
    };
    const s = sizes[size];
    const content = (
        <div className="flex items-center gap-2" data-testid="brand-logo">
            <div className="flex flex-col leading-none">
                <span className={`font-serif-display font-bold ${s.title}`} style={{ color: "var(--sss-text)" }}>
                    Sugar
                </span>
                <span
                    className={`font-script ${s.sub} -mt-1`}
                    style={{ color: "var(--sss-pink)" }}
                >
                    Sweet Society
                </span>
            </div>
            <Sparkles size={s.icon} className="text-[var(--sss-pink)] -mt-3" strokeWidth={1.5} />
        </div>
    );
    if (!linkable) return content;
    return (
        <a href="/" className="block" aria-label="Sugar Sweet Society home">
            {content}
        </a>
    );
};
